import React from "react";
import PropTypes from "prop-types";

import MenuModulo from "./MenuModulo";
import { Cargando } from "./Estados";

/**
 * Esqueleto comun de las pantallas del modulo: menu arriba, contenido abajo y
 * el estado de carga resuelto en un solo lugar.
 */
const LayoutModulo = ({
  opciones,
  seleccion,
  onSeleccionar,
  cargando,
  children,
}) => (
  <div>
    <MenuModulo
      opciones={opciones}
      seleccion={seleccion}
      onSeleccionar={onSeleccionar}
    />
    <div className="contenido_modulo">{cargando ? <Cargando /> : children}</div>
  </div>
);

LayoutModulo.propTypes = {
  opciones: PropTypes.array.isRequired,
  seleccion: PropTypes.string.isRequired,
  onSeleccionar: PropTypes.func.isRequired,
  cargando: PropTypes.bool,
};

LayoutModulo.defaultProps = { cargando: false };

export default LayoutModulo;
